// logic
import { STATES } from '../constants';

const DELAY_IN_SECS = 2;

const availableFiltersMock = {
  states: [
    { code: STATES.PENDING },
    { code: STATES.REJECTED },
    { code: STATES.CANCELLED },
  ],
};

// get a mock
const getAvailableFilters = async (...args) => {
  await new Promise((r) => setTimeout(r, DELAY_IN_SECS * 1000));
  return availableFiltersMock;
};

export default getAvailableFilters;
